<!-- <div class="parent">
  <div class="grid">
    <span class="columnHeader" *ngFor="let t of columns">
      {{ t }}
    </span>
  </div>
  <div class="grid gridRow" *ngFor="let k of keywords">

    <span class="pertinent">{{ k.keyword }}</span>
    <span class="dateTime" *ngIf="isAdmin">{{ k.createdDateTime | date:'medium' }}</span>
    <span class="whodunit" *ngIf="isAdmin">{{ k.createdByUser }}</span>
  </div>
</div> -->
<div class="keywordHolder" [ngStyle]="{'max-height': isHandset ? '50vh' : '108px'}" *ngIf="keywordsAndFilters?.length">
  <!-- <div class="badge badge-pill badge-dark keyword ms-1 me-1 mb-1" *ngFor="let k of data" [innerHtml]="(k.keyword.toLowerCase()) | embolden : searchText : 0 : 'style=\'background-color: rgba(250, 250, 50, 0.6); color: black;\''"></div> -->
  <app-keyword-badge *ngFor="let k of keywordsAndFilters; trackBy: trackByUID"
   [keyword]="k" [editMode]="isAdmin" (deleteMeEmitter)="deleteMeEmitter.emit($event)" [fontSize]="fontSizeProxy" [searchText]="searchText" [filterMatchText]="filteredText"
   (filterByMeEmitter)="changePageEmitter.emit($event)" [restrictEdit]="keywordInsideFilterList(k.uid)">
  </app-keyword-badge>
   
</div>
<div class="recordCount" *ngIf="keywordsAndFilters?.length; else noData">
  {{ keywordsAndFilters.length }} keyword(s)
</div>
<ng-template #noData>
  <div class="recordCount">We don't have any Keywords for this record yet.</div>
</ng-template>
